import { render } from "./VerifyAccount.vue?vue&type=template&id=5e21f74a&scoped=true"
import script from "./VerifyAccount.vue?vue&type=script&lang=js"
export * from "./VerifyAccount.vue?vue&type=script&lang=js"

import "./VerifyAccount.vue?vue&type=style&index=0&id=5e21f74a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e21f74a"]])

export default __exports__